module.exports = __webpack_public_path__ + "img/36.165dfc1.png";